import { useEffect, useState } from 'react';

import { useAuthenticationContext } from '@climatepartner/app-shell';

import { FronteggAuthUser } from '../adapters/frontegg';
import { AuthUser } from '../ports/auth';

type UseAuthResult =
    | {
          isAuthenticated: true;
          user: AuthUser;
      }
    | {
          isAuthenticated: false;
          user: null;
      };

const useAuth = (): UseAuthResult => {
    const context = useAuthenticationContext();

    const [result, setResult] = useState<UseAuthResult>({
        isAuthenticated: false,
        user: null,
    });

    useEffect(() => {
        if (context.isAuthenticated) {
            setResult({
                isAuthenticated: true,
                user: new FronteggAuthUser(context),
            });
        } else {
            setResult({
                isAuthenticated: false,
                user: null,
            });
        }
    }, [context]);

    return result;
};

export default useAuth;
